import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const CloseTemplateTaskBulkDeadlineCommandsList: FC<
    CommandsListProps
> = ({ options = {} }) => {
    const {
        selectedCloseTemplateTaskCount = 0,
        closeTemplateTaskBulkDeadlineOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set due for ${selectedCloseTemplateTaskCount} ${pluralize("task", selectedCloseTemplateTaskCount)}`}
            options={closeTemplateTaskBulkDeadlineOptions}
        />
    );
};
